import type { InboxAttentionFilter } from "@/features/inbox/types/filter";

/**
 * AI-attention filters, rendered in the sidebar's "Echo AI" group.
 * Each `field` is a boolean rule in the contact query-builder registry - the
 * same rule the advanced filter popover builds - so these AND with whichever
 * conversation view is active rather than replacing it.
 *
 * One row: "Needs you" is every conversation Echo is waiting on a person for (a
 * question, a draft to approve, a handover), opened on the priority sort so
 * questions come first. The narrower rules stay in the advanced filters, and a
 * suggestion is a chip on the card.
 *
 * It sits beside the group's "Inbox" row, not under it: that view is everything
 * Echo is on, while a handover here has already switched it off.
 */
export const INBOX_ATTENTION_FILTERS: InboxAttentionFilter[] = [
  {
    field: "needsYou",
    label: "Needs you",
    icon: "solar:user-hand-up-linear",
    tone: "danger",
    countKey: "needsYou",
  },
];

/** Tailwind text colour per tone, for the row icon + count badge. */
export const ATTENTION_TONE_CLASS: Record<
  InboxAttentionFilter["tone"],
  string
> = {
  danger: "text-danger",
  warning: "text-warning",
};

// The URL serializer's attention fields: attention is a single-choice filter,
// so the URL carries the chosen field name rather than a rule blob. The
// sidebar's rows, plus `draftPending`, which the AI report's draft backlog
// links to.
export const INBOX_ATTENTION_FIELDS = [
  ...INBOX_ATTENTION_FILTERS.map((attention) => attention.field),
  "draftPending" as const,
];
